<template>
  <div id="app">
    <Login v-if="!isLoggedIn" @login-success="handleLoginSuccess" />
    <MainLayout v-else :user-info="userInfo" @logout="handleLogout" />
  </div>
</template>

<script>
import Login from './components/Login.vue'
import MainLayout from './components/MainLayout.vue'

export default {
  name: 'App',
  components: {
    Login,
    MainLayout
  },
  data() {
    return {
      isLoggedIn: false,
      userInfo: null
    }
  },
  methods: {
    handleLoginSuccess(userData) {
      this.isLoggedIn = true
      this.userInfo = userData
      console.log('用户登录成功:', userData)
    },
    handleLogout() {
      this.isLoggedIn = false
      this.userInfo = null
      // 清除本地存储的用户信息
      localStorage.removeItem('token')
      localStorage.removeItem('userInfo')
    },
    handleTokenExpired() {
      // Token过期，自动退出登录
      this.isLoggedIn = false
      this.userInfo = null
      // 显示提示信息
      alert('登录已过期，请重新登录')
      console.log('Token过期，自动退出登录')
    }
  },
  mounted() {
    // 页面加载时检查是否有有效的登录状态
    const token = localStorage.getItem('token')
    const userInfo = localStorage.getItem('userInfo')
    
    if (token && userInfo) {
      try {
        this.userInfo = JSON.parse(userInfo)
        this.isLoggedIn = true
      } catch (error) {
        console.error('解析用户信息失败:', error)
        // 清除无效的用户信息
        localStorage.removeItem('token')
        localStorage.removeItem('userInfo')
      }
    }
    
    // 监听token过期事件
    window.addEventListener('token-expired', this.handleTokenExpired)
  },
  beforeUnmount() {
    // 清理事件监听器
    window.removeEventListener('token-expired', this.handleTokenExpired)
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  width: 100%;
  height: 100vh;
}
</style>
